import { type Control, useFormContext, useFormState } from 'react-hook-form';

import { Button, type ButtonProps } from '../Button';

/**
 * Submit control for a form.
 */
export function Submit(props: ButtonProps) {
    const { disabled, ...rest } = props;
    const form = useFormContext();
    const formState = useFormState({ control: form.control });
    const isDirty = useIsFormDirty(form.control);
    return (
        <Button
            type="submit"
            disabled={disabled ?? !isDirty}
            loadable={[formState.isSubmitting]}
            {...rest}
        />
    );
}

/**
 * Return true if a form is dirty.
 */
export function useIsFormDirty(control: Control<any>) {
    const formState = useFormState({ control });

    // Do not rely on `formState.isDirty` because if we use `setValue('', { shouldDirty: true })`
    // the formState is not updated.
    return Object.values(formState.dirtyFields).some((v) => v);
}
